import { command } from "@lookiero/messaging";
import { NotificationType } from "../model/notification";
const CREATE_TOAST_NOTIFICATION = "create_toast_notification";
const createToastNotification = ({ aggregateId, ...payload }) => ({
    ...command({ aggregateId, name: CREATE_TOAST_NOTIFICATION }),
    ...payload,
    type: NotificationType.TOAST,
});
export { CREATE_TOAST_NOTIFICATION, createToastNotification };
